import './ccf-emoji-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfEmojiIconProps extends SvgIconProps  {}
/**
 * component used to display Emoji icon
 * @param props - CcfEmojiIconProps
 * @example - <CcfEmojiIcon />
 * @returns SVG of emoji icon
 */
export function CcfEmojiIcon(props: CcfEmojiIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="emoji_icon"
        data-name="Emoji"
        transform="translate(3.702 6)"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <path
          id="emoji"
          d="M13.7,10.1a.9.9,0,1,0-.9-.9A.9.9,0,0,0,13.7,10.1Zm-5.4,0a.9.9,0,1,0-.9-.9A.9.9,0,0,0,8.3,10.1ZM11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm0,16.2A7.2,7.2,0,1,1,18.2,11,7.2,7.2,0,0,1,11,18.2Zm3.852-6.408a.9.9,0,0,0-1.26-.144A2.5,2.5,0,0,0,12.8,12.8H9.515a2.529,2.529,0,0,0-.792-1.179.9.9,0,0,0-1.1,1.431.9.9,0,0,1,.225.648.981.981,0,0,1-.225.648.9.9,0,1,0,1.125,1.4A2.6,2.6,0,0,0,9.506,14.6H12.8a2.448,2.448,0,0,0,.8,1.179.9.9,0,0,0,1.089-1.431.9.9,0,0,1-.225-.648.981.981,0,0,1,.225-.648A.9.9,0,0,0,14.852,11.792Z"
          transform="translate(-2 -2)"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfEmojiIcon;
